import _pick from 'lodash/pick'
import _pickBy from 'lodash/pickBy'

export function getValidators ($v) {
  return _pick($v, Object.keys($v.$params))
}

export function getValidationWithoutAggregatedValues ($v) {
  /*
    Hotfix to disable reactivity in object (it converts all getters to plain values)
    For some unknown reason, meeting.$invalid getter used to return false when adding more meetings,
    even if initial value was true. We want to control validation of whole by using @validation events,
    not by usingreactive objects from distant part of application, that's why we don't need reactivity here.
    However, I'm not sure why it was working like that (why this object's getter was changing its value). Maybe vuelidate tries to mimic vue reactivity somehow.
    https://www.notion.so/coursedog1/Invalid-Event-Meeting-doesn-t-prevent-the-Submit-button-after-certain-actions-9ebde48097d24b718e2f7c6c9b6f973c
    TODO: Remove and replace with new vuelidate, pls
  */
  return JSON.parse(JSON.stringify(_pickBy($v, (_, property) => property.indexOf('$') !== 0)))
}

// Merging

function _any (validations, prop) {
  return Object.values(validations).some($v => $v[prop])
}

function _all (validations, prop) {
  return Object.values(validations).every($v => $v[prop])
}

function _setDirtyRecursive (newState) {
  this.$dirty = newState
  const method = newState ? '$touch' : '$reset'
  Object.keys(getValidationWithoutAggregatedValues(this)).forEach(key => this[key][method]())
}

function Validation (props) {
  Object.assign(this, props)
}

Validation.prototype.$touch = function $touch () {
  return _setDirtyRecursive.call(this, true)
}

Validation.prototype.$reset = function $reset () {
  return _setDirtyRecursive.call(this, false)
}

export function combineValidations (validations) {
  const $invalid = _any(validations, '$invalid')
  const $dirty = _all(validations, '$dirty')
  const $anyDirty = _any(validations, '$dirty') || _any(validations, '$anyDirty')
  const $pending = _any(validations, '$pending')
  const $error = $dirty && !$pending && $invalid
  const $anyError = $anyDirty && !$pending && $invalid
  return new Validation({
    $invalid,
    $dirty,
    $anyDirty,
    $pending,
    $error,
    $anyError,
    ...validations,
  })
}
